const WhatsAppIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10906_32055)">
        <path
          d="M10.0023 0.833008H9.99769C4.94342 0.833008 0.833313 4.94426 0.833313 9.99967C0.833313 12.0049 1.47956 13.8634 2.57842 15.3725L1.43602 18.7779L4.95946 17.6515C6.40894 18.6118 8.138 19.1663 10.0023 19.1663C15.0565 19.1663 19.1666 15.0539 19.1666 9.99967C19.1666 4.9454 15.0565 0.833008 10.0023 0.833008ZM15.3361 13.7775C15.115 14.402 14.2373 14.9199 13.5372 15.0711C13.0582 15.1731 12.4326 15.2545 10.3265 14.3813C7.63269 13.2653 5.8979 10.5279 5.76269 10.3503C5.63321 10.1727 4.67415 8.90082 4.67415 7.5854C4.67415 6.26999 5.34217 5.62947 5.61144 5.35447C5.83258 5.12874 6.1981 5.02561 6.54873 5.02561C6.66217 5.02561 6.76415 5.03134 6.85581 5.03592C7.12508 5.04738 7.26029 5.06342 7.4379 5.48853C7.65904 6.02134 8.19758 7.33676 8.26175 7.47197C8.32706 7.60717 8.39237 7.79051 8.30071 7.96811C8.21477 8.15144 8.13915 8.2328 8.00394 8.38863C7.86873 8.54447 7.7404 8.66363 7.60519 8.83092C7.48144 8.97645 7.34165 9.13228 7.49748 9.40155C7.65331 9.66509 8.19185 10.5439 8.98477 11.2498C10.008 12.1607 10.8376 12.4518 11.1344 12.5755C11.3555 12.6672 11.619 12.6454 11.7806 12.4735C11.9857 12.2524 12.2389 11.8857 12.4967 11.5248C12.6801 11.2658 12.9115 11.2337 13.1545 11.3254C13.402 11.4113 14.7116 12.0587 14.9809 12.1928C15.2502 12.328 15.4278 12.3922 15.4931 12.5056C15.5573 12.619 15.5573 13.1519 15.3361 13.7775Z"
          fill="#33D54E"
        />
      </g>
      <defs>
        <clipPath id="clip0_10906_32055">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WhatsAppIcon;
